// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"b5dfb131","513":"faadc7b1","703":"5630038c","787":"e6950efe"}[chunkId] + ".chunk.js";
};